import type { ActivityComponentType } from '@stackflow/react';
import { DesktopMessagesView } from '@/features/messaging';

const MessagesActivity: ActivityComponentType = () => {
  return <DesktopMessagesView />;
};

export default MessagesActivity;
